import React from 'react'
import PropTypes from 'prop-types'

import styles from './Intro.module.css'
import buttons from '../../Buttons2.module.css'

Intro.propTypes = {
  course: PropTypes.object.isRequired
}

export default function Intro ({ course }) {
  if (!course.course_summary) return null

  return (
    <div className={styles.root}>
      <div className={styles.summary}>
        {course.course_summary}
      </div>

      <div className={styles.action}>
        <a href="/abitur/2021" className={buttons.main}>
          Приёмная комиссия
        </a>

        <br />

        <a href="https://abit.lunn.ru/" className={buttons.sec}>
          Подать документы
        </a>
      </div>

      {/* {course.youtube &&
        <div className={styles.youtube}>
          <iframe src={`https://www.youtube.com/embed/${course.youtube}`} frameBorder="0" allowFullScreen={true}></iframe>
        </div>
      } */}

      {course.youtube &&
        <div className={styles.youtube}>
          {(() => {
            const isYouTube = course.youtube.includes('youtube.com') || course.youtube.length === 11;
            const isVimeo = course.youtube.includes('vimeo.com');
            const isDirectLink = !isYouTube && !isVimeo;

            if (isYouTube) {
              return (
                <iframe
                  src={`https://www.youtube.com/embed/${course.youtube}`}
                  frameBorder="0"
                  allowFullScreen
                />
              );
            } else if (isVimeo) {
              return (
                <iframe
                  src={`https://player.vimeo.com/video/${course.youtube}`}
                  frameBorder="0"
                  allowFullScreen
                />
              );
            } else if (isDirectLink) {
              return (
                <video controls>
                  <source src={course.youtube} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              );
            }
          })()}
        </div>
      }


    </div>
  )
}





// import React from 'react'
// import PropTypes from 'prop-types'
// import VideoPlayer from '../../Common/VideoPlayer'
// import styles from './Intro.module.css'
// import buttons from '../../Buttons2.module.css'

// const Intro = ({ course }) => {
//   if (!course.course_summary) return null

//   return (
//     <div className={styles.root}>
//       <div className={styles.summary}>
//         {course.course_summary}
//       </div>

//       <div className={styles.action}>
//         <a href="/abitur/2021" className={buttons.main}>
//           Приёмная комиссия
//         </a>
//         <a href="https://abit.lunn.ru/" className={buttons.sec}>
//           Подать документы
//         </a>
//       </div>

//       {course.video_html && (
//         <div className={styles.youtube}>
//           <VideoPlayer html={course.video_html} />
//         </div>
//       )}
//     </div>
//   )
// }

// Intro.propTypes = {
//   course: PropTypes.shape({
//     course_summary: PropTypes.string,
//     video_html: PropTypes.string,
//     // Для обратной совместимости
//     youtube: PropTypes.string
//   }).isRequired
// }

// export default Intro